import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { getCurrentLanguage } from '@telecom/shared/utils/language-tool';

export interface AgentExample {
    text: string;
    other: any;
}

export interface BilingualExample {
    cn: string;
    en: string;
}

/**
 * 示例服务基类
 * 提供通用的双语示例数据处理逻辑
 */
@injectable()
export abstract class BaseExampleService {
    /**
     * 获取示例数据（子类需实现）
     */
    protected abstract getExamplesData(): BilingualExample[];

    /**
     * 获取示例列表
     * 根据当前语言环境返回对应语言的示例
     */
    getExamples(): AgentExample[] {
        const lang = getCurrentLanguage();
        const langKey = lang === 'cn' ? 'cn' : 'en';

        return this.getExamplesData().map(item => ({
            text: item[langKey],
            other: null,
        }));
    }
}
